import { FC } from "react";

type Props = {
  color?: string;
  size?: number;
};

const SettingsIcon: FC<Props> = ({ color, size = 16 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.46667 14L6.2 12.2C6.06667 12.1444 5.93333 12.0722 5.8 11.9833C5.66667 11.8944 5.53889 11.8 5.41667 11.7L3.75 12.4167L2.21667 9.75L3.65 8.66667C3.63889 8.59444 3.63333 8.51944 3.63333 8.44167V7.55833C3.63333 7.48056 3.63889 7.40556 3.65 7.33333L2.21667 6.25L3.75 3.58333L5.41667 4.3C5.53889 4.2 5.66667 4.10556 5.8 4.01667C5.93333 3.92778 6.06667 3.85556 6.2 3.8L6.46667 2H9.53333L9.8 3.8C9.93333 3.85556 10.0667 3.92778 10.2 4.01667C10.3333 4.10556 10.4611 4.2 10.5833 4.3L12.25 3.58333L13.7833 6.25L12.35 7.33333C12.3611 7.40556 12.3667 7.48056 12.3667 7.55833V8.44167C12.3667 8.51944 12.3556 8.59444 12.3333 8.66667L13.7667 9.75L12.2333 12.4167L10.5833 11.7C10.4611 11.8 10.3333 11.8944 10.2 11.9833C10.0667 12.0722 9.93333 12.1444 9.8 12.2L9.53333 14H6.46667ZM8 10.3333C8.64444 10.3333 9.19444 10.1056 9.65 9.65C10.1056 9.19444 10.3333 8.64444 10.3333 8C10.3333 7.35556 10.1056 6.80556 9.65 6.35C9.19444 5.89444 8.64444 5.66667 8 5.66667C7.35556 5.66667 6.80556 5.89444 6.35 6.35C5.89444 6.80556 5.66667 7.35556 5.66667 8C5.66667 8.64444 5.89444 9.19444 6.35 9.65C6.80556 10.1056 7.35556 10.3333 8 10.3333Z"
        fill="#2E2E2E"
      />
    </svg>
  );
};

export default SettingsIcon;
